import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		snsList: [
			// {
			// 	icon: 'mdi-facebook',
			// 	link: '',
			// },
			// {
			// 	icon: 'mdi-instagram',
			// 	link: '',
			// },
			// {
			// 	icon: 'mdi-youtube',
			// 	link: '',
			// },
		],
		tabList: [
			{
				title: 'About Us',
				link: 'about',
			},
			{
				title: 'Team',
				link: 'team',
			},
			{
				title: 'Portfolio',
				link: 'portfolios',
			},
			{
				title: 'Notice',
				link: 'notice',
			},
			{
				title: 'Contact',
				link: 'contact',
			},
		],
		leftNavDrawer: true,
	},
	mutations: {},
	actions: {},
	modules: {},
})
